import { render, staticRenderFns } from "./Create_user.vue?vue&type=template&id=34333d39&"
import script from "./Create_user.vue?vue&type=script&lang=js&"
export * from "./Create_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/yong9/vege_v2/vege_v2/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VStepper } from 'vuetify/lib'
import { VStepperContent } from 'vuetify/lib'
import { VStepperItems } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout,VSpacer,VStepper,VStepperContent,VStepperItems,VTab,VTabs})
